import { DrawerBody, DrawerFooter } from "@chakra-ui/react";
import { CheckCompensationButton, LogInButton } from "../../../HeaderButtons";
import type { HeaderNavProps } from "../../HeaderNav.d";

export const MobileMenuContent = ({
  headerButtons,
  menuItems,
}: Pick<HeaderNavProps, "headerButtons" | "menuItems">) => (
  <>
    <DrawerBody p={4} mt={16} fontSize={{ base: 18, lg: 16 }} borderTop="1px" borderColor="greyscale.400">
      {menuItems}
    </DrawerBody>
    {headerButtons && (
      <DrawerFooter flexDirection="column" gap={3} px={4} pt={8} borderTop="1px" borderColor="greyscale.400">
        {/* For the experiment buttons are hardcoded */}
        <CheckCompensationButton variant="primary" />
        <LogInButton labelKey="button_your_account" variant="link" />
      </DrawerFooter>
    )}
  </>
);
